import { defineAllowRoutes } from '@router/settingMethods'
import RegisterInput from '@views/register/RegisterInput.vue'
import RegisterPincode from '@views/register/RegisterPincode.vue'
import RegisterConfirm from '@views/register/RegisterConfirm.vue'

export default [
  {
    path: '/user/register/input',
    name: 'RegisterInput',
    component: RegisterInput,
    // props: (route) => ({
    //   codeRequestId: route.params.codeRequestId,
    //   email: route.query.email
    // }),
    meta: {
      nav: 'back',
      title: '新規会員登録',
      gaTitle: '新規会員登録',
      footer: true
    }
  },
  {
    path: '/user/register/confirm',
    name: 'RegisterConfirm',
    component: RegisterConfirm,
    props: true,
    // beforeEnter: (to, from, next) => {
    //   console.log('confirm')
    //   if (from.name === 'RegisterInput') {
    //     next()
    //   } else {
    //     // todoここでいいのか確認
    //     next({ name: 'Login' })
    //   }
    // },
    meta: {
      nav: 'back',
      title: '新規会員登録',
      gaTitle: '新規会員登録',
      footer: true
    }
  },
  {
    path: '/user/register/pincode',
    name: 'RegisterPincode',
    component: RegisterPincode,
    props: true,
    // beforeEnter: (to, from, next) => {
    //   console.log('confirm')
    //   if (from.name === 'RegisterInput') {
    //     next()
    //   } else {
    //     // todoここでいいのか確認
    //     next({ name: 'Login' })
    //   }
    // },
    meta: {
      nav: 'back',
      title: '新規会員登録',
      gaTitle: '新規会員登録',
      footer: true
    }
  }
]
